import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  private readonly loadingSubject$ = new BehaviorSubject<boolean>(false);

  public loader(): Observable<boolean> {
    return this.loadingSubject$.asObservable();
  }

  public show(): void {
    this.loadingSubject$.next(true);
  }

  public hide(): void {
    this.loadingSubject$.next(false);
  }
}
